<div *transloco="let t">
    <a [href]="eventDetailsUrl" style="display:none" aria-hidden="true"></a>
    <div class="event-card"
         [class.zoom-wrapper]="isClickable"
         [class.clickable]="isClickable"
         [class.p-15]="currentLayout === CalendarViewType.LIST"
         [class.border]="hasBorder"
         [class.no-shadow]="hideShadow"
         (click)="handleCardClick()">

        <div [class.zoom-target]="isClickable">
            <ng-template [ngTemplateOutlet]="currentLayout === CalendarViewType.LIST ? listItem : gridItem"/>
        </div>
    </div>

    <!-- LIST ITEM -->
    <ng-template #listItem>
        <div class="d-flex flex-column">
            <div class="d-flex gap-3">
                <div class="position-relative flex-shrink-0">
                    <ng-template [ngTemplateOutlet]="eventImage" [ngTemplateOutletContext]="{ cls: 'list', small: smallImage }"/>
                </div>

                <div class="d-flex flex-column flex-grow-1 min-width-0">
                    <div class="d-flex gap-2 pb-2">
                        <ng-template [ngTemplateOutlet]="roundTag"/>
                        <ng-template [ngTemplateOutlet]="bonusTag"/>
                        @if (!isLeagueEvent) {
                        <ng-template [ngTemplateOutlet]="statusTag"/>

                        }
                        <ng-template [ngTemplateOutlet]="sportTag"/>
                    </div>

                    <p class="fs-20 fw-500 pb-3">
                        <ng-template [ngTemplateOutlet]="eventName"/>
                    </p>
                    <div class="d-flex flex-column flex-xl-row gap-0 gap-xl-2">
                        <div class="d-flex align-items-center pb-2 color-slate-600">
                            <p class="text-truncate color-slate-600">
                                <app-event-date-display [start]="eventItem?.start" [end]="eventItem?.end" [showIcon]="hasIcons"/>
                            </p>
                        </div>
                        <div class="d-flex flex-column flex-md-row gap-0 gap-md-2">
                            <div class="pb-2">
                                <ng-template [ngTemplateOutlet]="eventLocation"/>
                            </div>
                            @if (eventItem?.competitorCount && showCompetitorCount) {
                            <div class="d-flex align-items-center pb-2">
                                <ng-template [ngTemplateOutlet]="competitorCount"/>
                            </div>
                            }
                        </div>
                    </div>
                    <ng-template [ngTemplateOutlet]="eventLengths"/>
                </div>

                <div class="d-flex flex-column flex-shrink-0 align-items-end justify-content-between">
                    <div class="d-flex gap-2">
                        @if (hasShare) {
                        <div class="favorite-event-indicator">
                            <img src="assets/icons/icons-alt/share-alt.svg" alt="Podijeli"/>
                        </div>
                        }
                        @if (hasFavorite) {
                        <div class="favorite-event-indicator">
                            <app-favorite-event-indicator [eventItem]="eventItem" [isXsComponent]="true"/>
                        </div>
                        }
                    </div>

                    <div class="d-flex justify-content-end">
                        @if (showActionButton) {
                        <ng-template [ngTemplateOutlet]="actionButton"/>
                        }
                    </div>
                </div>
            </div>
            <ng-template [ngTemplateOutlet]="registrationCloses"/>
            @if (isLeagueEvent
            && eventItem?.leagueTemplateStatus
            && statusBanners[eventItem!.leagueTemplateStatus!]; as banner) {
            <ng-template [ngTemplateOutlet]="eventBanner" [ngTemplateOutletContext]="banner"/>
            }
        </div>

    </ng-template>

    <!-- GRID ITEM -->
    <ng-template #gridItem>
        <div class="d-flex flex-column pb-3">
            <div class="position-relative flex-shrink-0">
                @if (eventItem?.sportOne || eventItem?.sportTwo) {
                <div class="tag italic py-1 fs-14 bold absolute absolute--top-sm">
                    <p class="text-uppercase">{{ eventItem?.sportOne ? t("app.common.sports." + eventItem?.sportOne) : t("app.common.sports." + eventItem?.sportTwo) }}</p>
                    </div>
                }
                @if (hasFavorite) {
                  <div class="favorite-event-indicator sm absolute">
                    <app-favorite-event-indicator [eventItem]="eventItem" [isXsComponent]="true"/>
                  </div>
                }
                <ng-template [ngTemplateOutlet]="eventImage" [ngTemplateOutletContext]="{ cls: 'grid' }"/>
            </div>


            <div class="d-flex flex-column flex-grow-1 min-width-0 px-12 pt-2">
              <div class="d-flex justify-content-between align-items center pt-1">
                  <div class="d-flex gap-1">
                      <ng-template [ngTemplateOutlet]="roundTag"/>
                      <ng-template [ngTemplateOutlet]="bonusTag"/>
                      @if (isFinishedEvent) {
                      <ng-template [ngTemplateOutlet]="statusTag"/>
                      }
                      @else {
                      <div></div>
                      }
                      <ng-template [ngTemplateOutlet]="canceledTag"/>
                  </div>

                  @if(showCompetitorCount) {
                    <ng-template [ngTemplateOutlet]="competitorCount"/>
                  }
              </div>

              <div class="divider-horizontal margin-8"></div>

              <div class="d-flex flex-column gap-1">
                  <div class="event-name">
                      <p class="fs-18 fw-500">
                          <ng-template [ngTemplateOutlet]="eventName"/>
                      </p>
                  </div>


                <div class="d-flex align-items-center color-slate-600">
                    <p class="text-truncate color-slate-600">
                        <app-event-date-display [start]="eventItem?.start" [end]="eventItem?.end" [showIcon]="hasIcons"/>
                    </p>
                </div>
                <ng-template [ngTemplateOutlet]="eventLocation"/>
                <ng-template [ngTemplateOutlet]="eventLengths"/>

                @if (showActionButton) {
                  <div class="mt-1">
                    <ng-template [ngTemplateOutlet]="actionButton"/>
                  </div>
                }
              </div>
                <ng-template [ngTemplateOutlet]="registrationCloses"/>
                @if (isLeagueEvent
                    && eventItem?.leagueTemplateStatus
                    && eventItem?.leagueTemplateStatus !== LeagueTemplateEventStatus.CANCELLED
                    && statusBanners[eventItem!.leagueTemplateStatus!]; as banner) {
                 <ng-template [ngTemplateOutlet]="eventBanner" [ngTemplateOutletContext]="banner"/>
                }
            </div>
        </div>
    </ng-template>



    <ng-template #eventBanner let-icon="icon" let-color="color" let-key="key" let-params="params">
        <div class="divider-horizontal width-100 mt-3 mb-2"></div>
        <div class="d-flex align-items-center gap-1 {{color}}">
            <img src="assets/icons/icons-alt/{{icon}}.svg" alt="Warning" [width]="18" [height]="18"/>
            <p class="fs-12 ps-1 fs-500">{{ t(key, params) | uppercase }}</p>
        </div>
    </ng-template>

    <ng-template #registrationCloses>
        @if (showRegistrationCloses && registrationClosesDays) {
        <ng-template [ngTemplateOutlet]="eventBanner"
                     [ngTemplateOutletContext]="{ icon: 'clock-icon-orange', color: 'color-orange-600', key: 'league.overview.registration.closes', params: { days: registrationClosesDays } }"/>
        }
    </ng-template>



    <ng-template #eventImage let-cls="cls" let-small="small">
        <img src="{{eventItem?.imageMedium || ''}}"
             alt="Event Image"
             class="bck-img {{cls}}"
             [class.small]="small"
             [sportOne]="eventItem?.sportOne"
             [sportTwo]="eventItem?.sportTwo"
             appImageFallback/>
    </ng-template>

    <ng-template #eventName>
        <app-language-output
                [hrLabel]="eventItem?.name"
                [srLabel]="eventItem?.nameSr"
                [enLabel]="eventItem?.nameEng"
                [itLabel]="eventItem?.nameIta"
                [bsLabel]="eventItem?.nameBs"
                [siLabel]="eventItem?.nameSlo"
                [defaultLanguage]="eventItem?.defaultLanguage"
                [languages]="languages"/>
    </ng-template>

    <ng-template #actionButton>
        <app-button-alt
                [buttonHeight]="'40px'"
                [text]="t((registrationClosesDays && showRegistrationCloses) ? 'race.grid.register' : 'app.common.view.details')"
                [buttonColor]="(registrationClosesDays && showRegistrationCloses) ? 'var(--teal-500)' : 'transparent'"
                [textColor]="(registrationClosesDays && showRegistrationCloses) ? 'white' : 'var(--teal-500)'"
                [isFullWidth]="currentLayout === CalendarViewType.GRID"
                (onClickCallback)="onRightButtonClick()"/>
    </ng-template>

    <ng-template #statusTag>
        @if (isFinishedEvent) {
        <div class="tag dark-gray">
            <p class="text-uppercase">
                {{ t("event.item.status.2") }}
            </p>
        </div>
        }
    </ng-template>

    <ng-template #bonusTag>
        @if (isBonusEvent && isLeagueEvent) {
        <div class="tag amber bold">
            <img src="assets/icons/icons-alt/star-icon.svg" alt="star"/>
            <p class="text-uppercase ps-1">
                {{ t("league.details.event.type.2") }}
            </p>
        </div>
        }
    </ng-template>

    <ng-template #canceledTag>
        @if (eventItem?.leagueTemplateStatus === LeagueTemplateEventStatus.CANCELLED) {
        <div class="tag red bold">
            <p class="text-uppercase">
                {{ t("app.common.canceled") }}
            </p>
        </div>
        }
    </ng-template>

    <ng-template #roundTag>
        @if (isLeagueEvent && eventItem?.round) {
        <span class="tag mint bold">{{ t('race.details.round') + ' ' + eventItem!.round | uppercase }}</span>
        }
    </ng-template>

    <ng-template #sportTag>
           @if (eventItem?.sportOne || eventItem?.sportTwo) {
            <div class="tag italic bold">
                <p class="text-uppercase">{{ eventItem?.sportOne ? t("app.common.sports." + eventItem?.sportOne) : t("app.common.sports." + eventItem?.sportTwo) }}</p>
                </div>
        }
    </ng-template>

    <ng-template #eventLocation>
        <app-location-display [city]="eventItem?.city" [countryId]="eventItem?.country" [showIcon]="hasIcons" />
    </ng-template>

    <ng-template #eventLengths>
        <app-event-lengths-display [event]="eventItem" [showIcon]="hasIcons"/>
    </ng-template>

    <ng-template #competitorCount>
        <div class="d-flex align-items-center">
            <img src="assets/icons/icons-alt/applicants.svg" alt="applicants"/>
            <span class="ms-1 text-truncate color-slate-600">
                {{ !isFinishedEvent ? (eventItem?.competitorCount?.total ?? "0") : (eventItem?.competitorCount?.finished ?? "0") }}
            </span>
        </div>
    </ng-template>

</div>
